import { PUB_SUB_CHANNEL_MEMBER_POSTS } from '@wix/communities-blog-client-common';
import initApp from '../member-pages-common/init-app';
import reducer from './reducers';
import getRoutes from './get-routes';

initApp({
  reducer,
  routes: getRoutes(),
  appName: PUB_SUB_CHANNEL_MEMBER_POSTS,
});
